import { takeLatest, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as layoutActions from '../../reducers/layoutReducer/actions'
import * as Notifications from '../../components/Common/notification'
import * as reducerActions from '../../reducers/sucursalesReducer/actions'

function* genGetSucursales(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Obteniendo sucursales' })
    )

    // llamo a la acción que trae los rubros
    let nu = yield calls.getSucursales(e.payload)
    yield put(reducerActions.setSucursales(nu))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genGetSucursalById(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Recuperando sucursal' })
    )

    let result = yield calls.getSucursalById(e.payload.idSucursal)
    yield put(reducerActions.saveSucursal(result))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genBorrarSucursal(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Desactivando sucursal' })
    )

    yield calls.borrarSucursal(e.payload)
    Notifications.showSuccess('Sucursal desactivada')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genActivarSucursal(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Activando sucursal' })
    )

    yield calls.activarSucursal(e.payload)
    Notifications.showSuccess('Sucursal activada')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genSaveSucursal(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Guardando sucursal' })
    )

    let result = yield calls.saveSucursal(e.payload)
    if (result === '') {
      Notifications.showSuccess('Sucursal creada')

      if (e.history !== undefined) {
        e.history.goBack()
      }
    } else {
      Notifications.showError(result)
    }
    //yield put(reducerActions.saveUsuario(result))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genActualizarSucursal(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Actualizando sucursal' })
    )

    let result = yield calls.actualizarSucursal(e.payload)
    if (result === '') {
      Notifications.showSuccess('Sucursal actualizada')
    } else {
      Notifications.showError(result)
    }
    //yield put(reducerActions.saveUsuario(result))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* defaultSaga() {
  yield all([
    takeLatest(reducerActions.SAGA_GET_SUCURSALES, genGetSucursales),
    takeLatest(reducerActions.SAGA_GET_SUCURSAL_BY_ID, genGetSucursalById),
    takeLatest(reducerActions.SAGA_BORRAR_SUCURSAL, genBorrarSucursal),
    takeLatest(reducerActions.SAGA_ACTIVAR_SUCURSAL, genActivarSucursal),
    takeLatest(reducerActions.SAGA_SAVE_SUCURSAL, genSaveSucursal),
    takeLatest(reducerActions.SAGA_ACTUALIZAR_SUCURSAL, genActualizarSucursal),
  ])
}

export const sagas = [defaultSaga]
